import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { AuthContext } from '../context/AuthContext';
import Portfolio from '../components/Portfolio';
import '../styles/Charts.css';
import '../styles/Watchlist.css';

function PortfolioPage() {
  const { token } = useContext(AuthContext);

  if (!token) {
    return (
      <>
        <Helmet>
          <title>Anmeldung erforderlich | DynaStoxx</title>
          <meta name="description" content="Melde dich an, um dein Aktienportfolio zu verwalten und deine Investments zu verfolgen." />
          <meta name="robots" content="noindex, follow" />
        </Helmet>
        <div className="portfolio-container">
          <section className="overview-section">
            <div className="section-card">
              <div className="portfolio-overview">
                <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>
                  <i className="fas fa-lock text-primary" 
                    style={{ 
                      fontSize: '3rem', 
                      color: 'var(--primary-color)',
                      marginBottom: '1.5rem',
                      display: 'block'
                    }}
                  ></i>
                  <h2 style={{ 
                    color: 'var(--text-primary)',
                    marginBottom: '1rem',
                    fontSize: '1.75rem'
                  }}>
                    Anmeldung erforderlich
                  </h2>
                  <p style={{ 
                    color: 'var(--text-secondary)',
                    marginBottom: '2rem',
                    fontSize: '1.1rem',
                    lineHeight: '1.5'
                  }}>
                    Melde dich an, um dein Portfolio zu verwalten und deine Aktien zu verfolgen.
                  </p>
                  <div className="portfolio-login-actions">
                    <Link to="/login" className="app-btn app-btn--primary">
                      <i className="fas fa-sign-in-alt" aria-hidden="true"></i>
                      <span>Jetzt anmelden</span>
                    </Link>
                    <Link to="/register" className="app-btn app-btn--secondary">
                      <i className="fas fa-user-plus" aria-hidden="true"></i>
                      <span>Konto erstellen</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Mein Portfolio | DynaStoxx</title>
        <meta name="description" content="Verwalte und analysiere dein Aktienportfolio" />
      </Helmet>
      <div className="page-container">
        <div className="main-content">
          <Portfolio />
          <div className="section-divider"></div>
        </div>
      </div>
    </>
  );
}

export default PortfolioPage;